import React from 'react'

import { Helmet } from 'react-helmet'

import TopMenu from '../components/top-menu'
import Footer from '../components/footer'
import './foton-hub.css'

const FotonHub = (props) => {
  return (
    <div className="foton-hub-container10">
      <Helmet>
        <title>FOTON Product Design Case Study | Vlad Butucariu</title>
        <meta
          name="description"
          content="Product and UX/UI design for FOTON, connecting marketplace, creation, royalty, and collaboration tools in one digital-asset platform."
        />
        <meta
          property="og:title"
          content="FOTON Product Design Case Study | Vlad Butucariu"
        />
        <meta
          property="og:description"
          content="A complex product design system for digital-asset creators and traders."
        />
        <meta
          property="og:image"
          content="https://vladbutucariu.com/Images/og-default.png"
        />
        <link rel="canonical" href="https://vladbutucariu.com/foton-hub" />
        <meta
          property="og:url"
          content="https://vladbutucariu.com/foton-hub"
        />
      </Helmet>
      <div className="foton-hub-thq-wrapper-elm">
        <TopMenu text3="Capabilities"></TopMenu>
        <div className="foton-hub-thq-top-section-elm">
          <div className="foton-hub-thq-video-div-elm">
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="foton-hub-video"
            ></video>
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="foton-hub-thq-video-mobile-elm"
            ></video>
          </div>
          <div className="foton-hub-thq-section-elm1">
            <div className="foton-hub-thq-color-wrapper-elm1 project-page-shell">
              <div className="foton-hub-container11 project-page-intro">
                <div className="foton-hub-container12">
                  <div className="foton-hub-container13">
                    <img
                      alt="image"
                      src="/Images/tickerpurple.200.svg"
                      className="foton-hub-image10"
                    />
                    <div className="foton-hub-thq-title-elm">
                      <h1 className="foton-hub-text10 header-project">
                        <span>FOTON – Digital Assets Hub</span>
                        <br></br>
                      </h1>
                    </div>
                    <div className="foton-hub-thq-subtitle-elm">
                      <div className="foton-hub-thq-description-elm1">
                        <h2 className="foton-hub-thq-heading-elm">
                          <span>
                            FOTON is a trading and creation platform for digital
                            assets built on the Radix network. My role covered
                            product and UX/UI design, bringing marketplace,
                            creation, royalty, and collaboration tools into one
                            system for traders and creators.
                          </span>
                          <br></br>
                        </h2>
                      </div>
                      <div className="foton-hub-thq-tags-elm">
                        <label className="tag-label-big foton-hub-text15">
                          product design
                        </label>
                        <label className="foton-hub-text16 tag-label-big">
                          dapp
                        </label>
                        <label className="tag-label-big foton-hub-text17">
                          digital assets
                        </label>
                        <label className="tag-label-big foton-hub-text18">
                          ux/ui
                        </label>
                        <a
                          href="https://foton.is"
                          target="_blank"
                          rel="noreferrer noopener"
                          className="foton-hub-link"
                        >
                          <label className="foton-hub-text19 tag-label-big">
                            https://foton.is
                          </label>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="foton-hub-thq-description-elm2">
                  <div className="foton-hub-container14">
                    <span className="foton-hub-text20">context</span>
                    <span className="foton-hub-text21">
                      The rise of NFTs brought new opportunities for creators
                      and traders alike, but existing platforms struggled to
                      balance their needs. Traders wanted simple, secure tools
                      to maximize profits, while creators lacked intuitive
                      solutions for minting NFTs and fair control over
                      royalties. The FOTON team set out to design a platform
                      that addressed both groups, leveraging the strengths of
                      Radix DLT to offer security, ease of use, and flexibility.
                    </span>
                  </div>
                  <div className="foton-hub-container15">
                    <span className="foton-hub-text22">Design</span>
                    <span className="foton-hub-text23">
                      <span>
                        The first step was understanding the two user types —
                        traders and creators — and mapping their distinct
                        challenges. Traders required intuitive, clutter-free
                        interfaces with strong safeguards. Radix was the perfect
                        foundation, thanks to its native assets and transaction
                        previews that reduced risk and errors. 
                      </span>
                      <span>
                        Creators, however, faced the biggest frustrations:
                        reliance on developers for minting, limited control over
                        royalties, and poor tooling compared to their central
                        role in the ecosystem. To solve this, I designed Creator
                        Studio, a dedicated sub-application with a clear,
                        Web2-like flow. It allowed creators to build projects,
                        mint NFTs, and enforce advanced royalties in an
                        approachable, structured way. Another breakthrough was
                        designing a Web3-native collaboration system using NFT
                        badges for team permissions — a first-of-its-kind
                        feature in tokenization platforms. 
                      </span>
                      <span>
                        To strengthen community engagement, I borrowed patterns
                        from familiar apps like Discord. Projects and
                        collections could be pinned in a sidebar, mimicking
                        channel navigation and creating a sense of belonging and
                        continuity. This approach made the platform feel both
                        novel and approachable.
                      </span>
                    </span>
                  </div>
                  <div className="foton-hub-container16">
                    <span className="foton-hub-text27">Results</span>
                    <span className="foton-hub-text28">
                      The resulting design connected complex creation and
                      trading workflows through a consistent product language.
                      Familiar navigation, guided minting, and structured
                      royalty controls made the platform easier to approach
                      without hiding the capabilities of the underlying system.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="foton-hub-thq-section-elm2">
          <div className="foton-hub-thq-label-elm">
            <span className="foton-hub-text29">Loopers</span>
            <span className="foton-hub-text30">
              animation, nft, collection, art
            </span>
          </div>
          <div className="foton-hub-container17">
            <div className="foton-hub-thq-item-elm10">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="foton-hub-image11"
              />
            </div>
            <div className="foton-hub-thq-item-elm11">
              <img
                alt="image"
                src="/Images/alwayslate2.svg"
                className="foton-hub-image12"
              />
            </div>
            <div className="foton-hub-thq-item-elm12">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="foton-hub-image13"
              />
            </div>
            <div className="foton-hub-thq-item-elm13">
              <img
                alt="image"
                src="/Images/alwayslate4.svg"
                className="foton-hub-image14"
              />
            </div>
            <div className="foton-hub-thq-item-elm14">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="foton-hub-image15"
              />
            </div>
            <div className="foton-hub-thq-item-elm15">
              <img
                alt="image"
                src="/Images/alwayslate6.svg"
                className="foton-hub-image16"
              />
            </div>
            <div className="foton-hub-thq-item-elm16">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="foton-hub-image17"
              />
            </div>
            <div className="foton-hub-thq-item-elm17">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="foton-hub-image18"
              />
            </div>
            <div className="foton-hub-thq-item-elm18">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="foton-hub-image19"
              />
            </div>
            <div className="foton-hub-thq-item-elm19">
              <img
                alt="image"
                src="/Images/alwayslate2.svg"
                className="foton-hub-image20"
              />
            </div>
            <div className="foton-hub-thq-item-elm20">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="foton-hub-image21"
              />
            </div>
            <div className="foton-hub-thq-item-elm21">
              <img
                alt="image"
                src="/Images/alwayslate4.svg"
                className="foton-hub-image22"
              />
            </div>
            <div className="foton-hub-thq-item-elm22">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="foton-hub-image23"
              />
            </div>
            <div className="foton-hub-thq-item-elm23">
              <img
                alt="image"
                src="/Images/alwayslate6.svg"
                className="foton-hub-image24"
              />
            </div>
            <div className="foton-hub-thq-item-elm24">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="foton-hub-image25"
              />
            </div>
            <div className="foton-hub-thq-item-elm25">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="foton-hub-image26"
              />
            </div>
            <div className="foton-hub-thq-item-elm26">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="foton-hub-image27"
              />
            </div>
            <div className="foton-hub-thq-item-elm27">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="foton-hub-image28"
              />
            </div>
          </div>
        </div>
        <div className="foton-hub-thq-section-elm3">
          <div className="foton-hub-thq-color-wrapper-elm2">
            <div className="foton-hub-container18">
              <div className="foton-hub-thq-pic-elm">
                <img
                  alt="image"
                  src="/Projects/Web/foton%20hub%20w1.png"
                  className="foton-hub-image29"
                />
                <img
                  alt="image"
                  src="/Projects/Web/foton%20hub%20w3.png"
                  className="foton-hub-image30"
                />
                <div className="foton-hub-container19">
                  <div className="foton-hub-container20">
                    <div className="foton-hub-container21">
                      <img
                        alt="image"
                        src="/Projects/Web/foton%20hub%20w4.png"
                        className="foton-hub-image31"
                      />
                    </div>
                    <div className="foton-hub-container22">
                      <img
                        alt="image"
                        src="/Projects/Web/foton%20hub%20w9.png"
                        className="foton-hub-image32"
                      />
                    </div>
                  </div>
                  <div className="foton-hub-thq-description-elm3">
                    <p className="foton-hub-text31">
                      To boost engagement and create a sense of progression for
                      collectors, a gamification system was designed around key
                      platform activities such as trading, minting, and creating
                      collections. A native series of Tesseract NFTs
                      complemented this system, adding a competitive and
                      rewarding layer to the user experience.
                    </p>
                  </div>
                </div>
                <img
                  alt="image"
                  src="/Projects/Web/foton%20hub%20w2.png"
                  className="foton-hub-image33"
                />
                <div className="foton-hub-container23">
                  <img
                    alt="image"
                    src="/Projects/Web/foton%20hub%20w5.png"
                    className="foton-hub-image34"
                  />
                  <div className="foton-hub-thq-description-elm4">
                    <p className="foton-hub-text32">
                      The user interface adapts dynamically based on post-login
                      behavior — presenting tailored experiences for Collectors
                      or Creators. A dedicated sidebar displays relevant pages
                      and favorite collections, keeping users closely connected
                      to the content that matters most to them.
                    </p>
                  </div>
                </div>
                <div className="foton-hub-container24">
                  <div className="foton-hub-container25">
                    <img
                      alt="image"
                      src="/Projects/Web/foton%20hub%20w6.png"
                      className="foton-hub-image35"
                    />
                  </div>
                  <div className="foton-hub-container26">
                    <img
                      alt="image"
                      src="/Projects/Web/foton%20hub%20w7.png"
                      className="foton-hub-image36"
                    />
                  </div>
                </div>
                <div className="foton-hub-container27">
                  <div className="foton-hub-container28">
                    <img
                      alt="image"
                      src="/Projects/Web/foton%20hub%20w8.png"
                      className="foton-hub-image37"
                    />
                  </div>
                  <div className="foton-hub-container29">
                    <img
                      alt="image"
                      src="/Projects/Web/foton%20hub%20w10.png"
                      className="foton-hub-image38"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
  )
}

export default FotonHub
